/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Version: 1.1
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

const  GiftCardForm = () => import('./GiftCardForm.vue')
const  GiftCardFormNew = () => import('./GiftCardFormNew.vue')

const  GiftCardFormLaundry = () => import('./GiftCardFormLaundry.vue')

import Vue from 'vue'

import 'flex.box/src/flexbox.css'

import 'element-ui/lib/theme-chalk/index.css';

import ElementUI from 'element-ui';

Vue.config.productionTip = false
//setting english language
import locale from 'element-ui/lib/locale/lang/en'
Vue.use(ElementUI, { locale })

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(VueMoment, {
    moment,
})
// Set Vue authentication
Vue.use(VueAxios, axios)

axios.defaults.baseURL = `/api`

document.addEventListener('DOMContentLoaded', () => {

  const element = document.getElementById('giftcard')

  if (element != null) {
    let properties = {
        clientId    : element.dataset.clientId,
        stripeKey   : element.dataset.stripeKey,
        companyName : element.dataset.companyName,
        currency    : element.dataset.currency,
        locationId  : element.dataset.locationId,
    }

    new Vue({
      el: '#giftcard',
      components: {
        'giftcard-form': GiftCardForm,
        'giftcard-form-new': GiftCardFormNew,
        'giftcard-laundry-form': GiftCardFormLaundry,
      },
      props : properties,
    })

  }
})
